(function () {
	'use strict';

	var uid = 0;

	$.extend(TS, {

		/**
         * Returns a numeric ID
         * @returns {Number}
         * @static
         */
		newUID: function () {
			uid++;
			return -uid;
		},

		createEntity: function () {
			var document = {};
			document['UID'] = TS.newUID();
			document = ko.mapping.fromJS(document);
			delete document.__ko_mapping__.mappedProperties;
			document.__ko_mapping__.ignore.push('__ko_mapping__');
			document.__ko_mapping__.ignore.push('__id');
			document.__ko_mapping__.ignore.push('uid');
			return document;
		}
	});
})();
